import React, {Component} from 'react';
import '../../style/common-style.css';
import '../../style/login.css';
import '../../style/font-family.css';
import ErrorMessage from './ErrorMessage';
import {connect} from 'react-redux';
import * as Constants from '../common/Constants';

class Error extends Component {
    render() {
        return (
            <div className="error">
                <svg focusable="false" aria-hidden="true" className="icon top-svg">
                    <use xlink="http://www.w3.org/1999/xlink" href="#icon-error-circle"></use>
                </svg>
                    <label className="title" automationid="LoginPage_Label_ErrorOops_1">{this.props.eTitle}</label>
                    <ErrorMessage err_msg1={this.props.errorMessage1} err_msg2={this.props.errorMessage2} />
                <div className="space200"></div>
                <div className="bottom-section">
                    <label automationid="LoginPage_Label_ErrorOkay_2" className="btn btn-red" onClick={() => {
                        this.props.changeDisplay()
                    }}>OKAY</label>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setPageToBeDisplayed: (pageToBeDisplayed) => dispatch({
            type: Constants.SET_PAGE_TOBE_DISPLAYED,
            payload: pageToBeDisplayed
        })
    }
}

const mapStateToProps = state => {
    return {
        errorMessage1: state.errorMessage1,
        errorMessage2: state.errorMessage2,
        errorFrom: state.errorFrom
    }
}

// export default Error;
export default connect(mapStateToProps, mapDispatchToProps)(Error);